import type { SubMeteringSystem } from "../../../types/api.types";
import { getSystemDisplayNameFromValue } from "./getSystemDisplayNameFromValue";

export function getConfigurationDisplayName(
  configurationName: string,
  system: SubMeteringSystem
) {
  let displayName = configurationName;

  if (!displayName) {
    displayName = getSystemDisplayNameFromValue(system);
  }

  return displayName;
}
